export const matchStatusType = {
  inProgress: 'In progress',
  complete: 'Complete',
  waiting: 'Waiting',
};
